import { request } from '@langlois/request';

export async function getEventTypes ({ commit }) {
	try {
		const url = new URL(`${process.env.VUE_APP_API_URI}/club/event-type`);

		const response = await request.get(url);

		if (response.ok) {
			const eventTypes = await response.json();

			commit(`setEventTypes`, eventTypes);
		}
	} catch (error) {
		return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error.`,
			type: `warning`
		}, { root: true });
	}
}
